/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_EventsInputs */



/**
* | output |
* | --- |
* | "Events" |
*
* @param {League_Standings_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_events = /** @type {((inputs?: League_Standings_EventsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_EventsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Eventos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi")
	return /** @type {LocalizedString} */ ("Events")
});